import React from 'react'

interface Message {
  id: string
  sender: string
  content: string
  timestamp: Date
}

interface MessageItemProps {
  message: Message
}

const MessageItem: React.FC<MessageItemProps> = ({ message }) => {
  const formatTime = (date: Date) => {
    return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  return (
    <div className="message-item">
      <div className="message-header">
        <span className="message-sender">{message.sender}</span>
        <span className="message-time">{formatTime(message.timestamp)}</span>
      </div>
      <div className="message-content">{message.content}</div>
    </div>
  )
}

export default MessageItem
